import { BadgeVariants } from "ds/components/Badge/types";
import { OpenTofuMigrationState } from "types/generated";

type OpenTofuMigrationStateConfig = {
  variant: BadgeVariants;
  text: string;
};

export const OPEN_TOFU_MIGRATION_STATES: Record<
  OpenTofuMigrationState,
  OpenTofuMigrationStateConfig
> = {
  [OpenTofuMigrationState.ToMigrate]: { variant: "blue", text: "Queued" },
  [OpenTofuMigrationState.Migrated]: { variant: "green", text: "Migrated" },
  [OpenTofuMigrationState.ToRollback]: { variant: "yellow", text: "Rollback queued" },
  [OpenTofuMigrationState.Rolledback]: { variant: "gray", text: "Rolled back" },
  [OpenTofuMigrationState.Failed]: { variant: "red", text: "Failed" },
};

export const OPEN_TOFU_MIGRATION_FAILED_MIGRATION_TEXT = "Migration failed";
export const OPEN_TOFU_MIGRATION_FAILED_ROLLBACK_TEXT = "Rollback failed";

export const TERRAFORM_VENDOR_CONFIG_TYPENAME = "StackConfigVendorTerraform";
